export function exhaustiveCheck(_value: never): never {
  throw new Error('Statement should be unreachable', _value);
}
